
import { GatewayData,PcData,DeviceData,GatewayNetworkData} from '@/views/iot-console/components/extranetui/Extranet';
import {
DeviceConfigDto
} from "@/service-proxies/app-v2/iot-extranet.service-proxies";


export const generatePcData=(dto:DeviceConfigDto )=>{
  const result = new PcData();
  result.virtualIp = dto.deviceLocal?.virtualIp || "";
  return result;
}

export const generateGatewayData=(dto:DeviceConfigDto )=>{
  const result = new GatewayData();
  
  const lanList = dto.deviceGateway?.itemList || [];
  const networkDataList= lanList.map(c=>{
    const item = new  GatewayNetworkData();
    item.name=c.name;
    item.ip=c.ip;
    return item;
  });

  result.virtualIp = dto.deviceGateway?.virtualIp || "";
  result.code = dto.deviceGateway?.gatewayCode || "";
  result.networkDataList = networkDataList;
  return result;
}

export const  generateDeviceDataList=(dto:DeviceConfigDto )=>{
  if(dto.deviceDataList.length===0 && dto.deviceGateway.itemList.length===0){
    const item = new DeviceData();
    item.ipClone=false;
    item.linkGatewayIp = dto.deviceGateway.virtualIp;
    item.name = 'PC设备'
    item.physicalIp = dto.deviceLocal.virtualIp,
    item.virtualIp= dto.deviceLocal.virtualIp
    return [item];
  }
  return dto.deviceDataList.map((c,index)=>{
    const item = new DeviceData();
    item.ipClone=c.ipClone;
    item.linkGatewayIp = c.linkGatewayIp;
    item.name = (!c.deviceName || c.deviceName.length===0)?`设备${index+1}`: c.deviceName,
    item.physicalIp = c.lanIp,
    item.virtualIp= c.virtualIp
    return item;
  });
};